<!-- src/components/Common/IdleTimeoutWarning.vue -->
<!-- Global overlay shown during the idle-timeout warning window. -->
<!-- Countdown drives auto-logout; "Stay Signed In" resets the timer across tabs. -->

<template>
  <div
    v-if="idleTimer.warningActive.value"
    class="fixed inset-0 z-[12000] flex items-center justify-center bg-black/50"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="idle-warning-title"
  >
    <div class="w-full max-w-sm rounded-xl bg-white p-6 text-center shadow-xl">
      <div class="mb-3 flex justify-center">
        <Clock class="h-10 w-10 text-amber-500" />
      </div>
      <h2 id="idle-warning-title" class="mb-2 text-lg font-semibold text-gray-900">
        Are you still there?
      </h2>
      <p class="mb-5 text-sm text-gray-600">
        You'll be signed out in
        <span class="font-semibold text-gray-900">{{ formattedCountdown }}</span>
        due to inactivity.
      </p>
      <div class="flex justify-center gap-3">
        <button
          class="rounded bg-gray-100 px-4 py-2 text-sm text-gray-700 transition hover:bg-gray-200"
          @click="idleTimer.signOutNow()"
        >
          Sign Out Now
        </button>
        <button
          class="rounded bg-brand-blue px-4 py-2 text-sm text-white transition hover:bg-brand-blue/90"
          @click="idleTimer.stayLoggedIn()"
        >
          Stay Signed In
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Clock } from 'lucide-vue-next'
import { useIdleTimer } from '@/composables/useIdleTimer'

const idleTimer = useIdleTimer()

const formattedCountdown = computed(() => {
  const s = idleTimer.secondsUntilLogout.value
  if (s >= 60) {
    const m = Math.floor(s / 60)
    const r = s % 60
    return `${m}m ${r.toString().padStart(2, '0')}s`
  }
  return `${s}s`
})
</script>
